module.exports = __webpack_public_path__ + "static/media/stopwatch.b052196b.svg";